<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__rdaccountdailystat}">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
          </el-form-item>
          <el-form-item>
         
            <ren-dept-tree v-model="dataForm.companyId" placeholder="选择部门" :query="true" ref="tree"></ren-dept-tree>
          </el-form-item>
          <el-form-item>
            <el-button @click="getDataList('dept')">{{ $t('query') }}</el-button>
          </el-form-item>
          
  <!--        <el-form-item>-->
  <!--          <el-button v-if="$hasPermission('demo:rdaccountdailystat:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
  <!--        </el-form-item>-->
  <!--        <el-form-item>-->
  <!--          <el-button v-if="$hasPermission('demo:rdaccountdailystat:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
  <!--        </el-form-item>-->
        </el-form>
        <div class="pay_type">
          <div :class="isLian ? 'back1':'back2'" @click="lianPay">连连支付</div>
          <div :class="isTong ? 'back1':'back2'" @click="tongPay">统统付</div>
        </div>
        <div v-if="isLian">
          <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
            <el-table-column prop="deptName" label="机构名称" header-align="center" align="center"></el-table-column>
            <el-table-column prop="txn_type" label="交易类型" header-align="center" align="center"></el-table-column>
            <el-table-column prop="oid_acctno" label="账户号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="amt" label="交易金额" header-align="center" align="center">
              <template slot-scope="scope">
                {{isLian ? (scope.row.flag_dc == "CREDIT" ? '+' : "-") + scope.row.amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","): null}}
              </template>
            </el-table-column>
            <el-table-column prop="amt_bal" label="账户余额" header-align="center" align="center">
              <template slot-scope="scope">
                <div>{{isLian ? scope.row.amt_bal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="txn_time" label="交易日期" header-align="center" align="center"></el-table-column>
            <el-table-column prop="jno_cli" label="本系统交易单号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="jno_acct" label="资金流水号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="accp_txnno" label="ACCP系统交易单号" header-align="center" align="center"></el-table-column>
          </el-table>
        </div>
        <div v-if="isTong">
          <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
            <el-table-column prop="deptName" label="机构名称" header-align="center" align="center"></el-table-column>
            <el-table-column prop="tradeType" label="交易类型" header-align="center" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.tradeType == '01'">支付</span>
                <span v-if="scope.row.tradeType == '02'">退款</span>
                <span v-if="scope.row.tradeType == '03'">提现</span>
                <span v-if="scope.row.tradeType == '04'">充值</span>
                <span v-if="scope.row.tradeType == '05'">转账</span>
                <span v-if="scope.row.tradeType == '08'">退票</span>
                <span v-if="scope.row.tradeType == '09'">余额退款</span>
                <span v-if="scope.row.tradeType == '10'">充退</span>
              </template>
            </el-table-column>
            <el-table-column prop="merNo" label="账户号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="transAmount" label="交易金额" header-align="center" align="center">
              <template slot-scope="scope">
                <div>￥{{scope.row.transAmount ? scope.row.transAmount.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="transFee" label="手续费" header-align="center" align="center">
              <template slot-scope="scope">
                <div>￥{{scope.row.transFee ? scope.row.transFee.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="dealDate" label="交易日期" header-align="center" align="center">
              <template slot-scope="scope">
                {{ formatDateString(scope.row.dealDate) }}
              </template>
            </el-table-column>
           
            <el-table-column prop="dealTime" label="交易时间" header-align="center" align="center">
              <template slot-scope="scope">
                {{ formatTimeString(scope.row.dealTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="settlementDate" label="清算日期" header-align="center" align="center">
              <template slot-scope="scope">
                {{ formatDateString(scope.row.settlementDate) }}
              </template>
            </el-table-column>
            <el-table-column prop="tradeNo" label="统统付平台交易单号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="orderNo" label="商户订单号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="gatherType" label="收取模式" header-align="center" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.gatherType == '0'">实收</span>
                <span v-if="scope.row.gatherType == '1'">后收</span>
              </template>
            </el-table-column>
            <el-table-column prop="withholdType" label="扣款方式" header-align="center" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.withholdType == '0'">内扣</span>
                <span v-if="scope.row.withholdType == '1'">外扣</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
import { set } from 'lodash';
 
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          //api/acctserial/queryAcctserial
          getDataListURL: '/api/acctserial/queryAcctserial',
          // getDataListURL: '/sys/tcdetail/page',
          getDataListIsPage: true,
          exportURL: '/sys/tcdetail/export',
          deleteURL: '/sys/tcdetail',
          deleteIsBatch: true
        },
        isLian:true,
        isTong:false,
        userType:[],
        date:'',
        dataForm: {
          companyId:'',
          "acctType": "",
          "dateEnd": "",
          "dateStart": "",
          "flagDc": "",
          "userId": "",
          dateEnd:"",
          dateStart:"",
          "payChannel": 0
        }
      }
    },
    watch:{
      $route:{
        handler(newVal,odlVal){
            this.dataForm.companyId = ''
            if(this.$refs.tree){
              this.$refs.tree.showDeptName = ''
            }
            this.getDataList()
        },
        deep:true,
        immediate:true
      }
   },
    methods: {
      formatDateString(dateStr) {
        if (!dateStr) return '';
        return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`;
      },
      formatTimeString(timeStr) {
        if (!timeStr) return '';
        return `${timeStr.slice(0, 2)}:${timeStr.slice(2, 4)}:${timeStr.slice(4, 6)}`;
      },
      lianPay(){
        this.page = 1
        this.isTong = false
        this.dataForm.payChannel = 0
        this.getDataList('dept')
        setTimeout(()=>{
          this.isLian = true    
        },300)
        
      },
      tongPay(){
        this.page = 1
        this.isLian = false
        this.dataForm.payChannel = 1
        this.getDataList('dept')  
        setTimeout(()=>{
          this.isTong = true
        },50)
      },
      xz(){
        console.log(111111111111)
      // console.log(id)
      //  this.dataForm.companyId = id
      },
      //利⽤change事件监听表单内容变化，并将选中的值赋值给所需要的两个字段
      //⽀付时间戳设置
      getTimes() {
        if (this.date != null) {
          this.dataForm.dateStart = this.date[0]
          this.dataForm.dateEnd = this.date[1]
        }else{
          this.dataForm.dateStart =''
          this.dataForm.dateEnd = ''
        }
      }
    }
  }
  </script>
<style scoped lang="scss">
  .pay_type{
    display: flex;
    margin-bottom: 20px;
    div{
      width: 100px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      margin-right: 20px;
      border-radius: 6px 6px 0 0;

    }
  }
  .back1{
    background-color: rgb(23,179,163); 
    color: #fff;
    cursor: pointer; 
  }
  .back2{
    background-color: #f2f2f2;
    cursor: pointer;
  }
</style>

  